import React, { useRef, useEffect, useState } from 'react';
import { Tooltip } from '@mui/material';

export interface ElipsisCellProps {
  width: string;
  text?: string;
  node?: React.ReactNode;
  parentRef?: any;
  className?: string;
  rootClassName?: string;
  onClick?: () => void
}

const ElipsisCell: React.FC<ElipsisCellProps> = ({
  node, text, width, parentRef, className, rootClassName, onClick
}) => {
  const textElementRef = useRef(null);
  const [hoverStatus, setHover] = useState(false);

  const compareSize = () => {
    // @ts-ignore
    const compare = textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
    setHover(compare);
  };

  useEffect(() => {
    compareSize();
  }, [text]);

  return (
    <td
      className={rootClassName}
      tabIndex={0}
      rowSpan={1}
      colSpan={1}
      style={{ width }}
      ref={parentRef}
    >
      <Tooltip
        title={text || ''}
        arrow
        disableHoverListener={!hoverStatus}
        classes={{
          tooltip: 'tooltip',
        }}
      >
        <div className={`elipsis ${className || ''}`} ref={textElementRef} style={{ maxWidth: width.replace('%', 'vw') }} onClick={onClick}>
          {node || text}
        </div>
      </Tooltip>
    </td>
  );
};

export default ElipsisCell;
